import Quill from 'quill';
import { getEditorContentWidth, redistributeColumnWidths } from './types';
function getCellColumnIndex(cell) {
    const td = cell.closest('td');
    if (!td?.parentElement)
        return 0;
    const index = Array.from(td.parentElement.querySelectorAll('td')).findIndex((el) => el === td);
    return index >= 0 ? index : 0;
}
function getRelativeRect(targetRect, container) {
    const containerRect = container.getBoundingClientRect();
    return {
        x: targetRect.x - containerRect.x - container.scrollLeft,
        y: targetRect.y - containerRect.y - container.scrollTop,
        x1: targetRect.x - containerRect.x - container.scrollLeft + targetRect.width,
        y1: targetRect.y - containerRect.y - container.scrollTop + targetRect.height,
        width: targetRect.width,
        height: targetRect.height,
    };
}
function updateBoundary(editor, state) {
    const { cell, tableSelection } = state;
    if (!cell)
        return false;
    const cellRect = cell.getBoundingClientRect();
    if (tableSelection) {
        tableSelection.setSelection(cellRect, cellRect);
        state.boundary = tableSelection.boundary;
    }
    else {
        // Construct boundary manually when tableSelection isn't initialized
        // (happens when operation menu is disabled via empty better-table config)
        // Must use relative coords matching quill-better-table's getRelativeRect
        const container = editor.root.parentNode;
        state.boundary = getRelativeRect(cellRect, container);
    }
    return true;
}
export function insertRow(editor, state, isDown) {
    if (!updateBoundary(editor, state))
        return;
    const affectedCells = state.tableContainer.insertRow(state.boundary, isDown, editor.root.parentNode);
    editor.update(Quill.sources.USER);
    if (affectedCells?.[0]) {
        editor.setSelection(editor.getIndex(affectedCells[0]), 0, Quill.sources.SILENT);
        state.tableSelection?.setSelection(affectedCells[0].domNode.getBoundingClientRect(), affectedCells[0].domNode.getBoundingClientRect());
    }
}
export function insertColumn(editor, state, isRight) {
    if (!updateBoundary(editor, state))
        return;
    // Capture width before insert — the DOM may expand after the column is added
    const editorWidth = getEditorContentWidth(editor);
    const colIndex = getCellColumnIndex(state.cell);
    const newColumn = state.tableContainer.insertColumn(state.boundary, colIndex, isRight, editor.root.parentNode);
    if (state.columnTool)
        state.columnTool.updateToolCells();
    editor.update(Quill.sources.USER);
    // Redistribute column widths so the table stays within editor width
    redistributeColumnWidths(editor, state.table, editorWidth);
    if (newColumn?.[0]) {
        editor.setSelection(editor.getIndex(newColumn[0]), 0, Quill.sources.SILENT);
        state.tableSelection?.setSelection(newColumn[0].domNode.getBoundingClientRect(), newColumn[0].domNode.getBoundingClientRect());
    }
}
export function deleteRow(editor, state) {
    if (!updateBoundary(editor, state))
        return;
    state.tableContainer.deleteRow(state.boundary, editor.root.parentNode);
    editor.update(Quill.sources.USER);
    state.tableSelection?.clearSelection();
}
export function deleteColumn(editor, state) {
    if (!updateBoundary(editor, state))
        return;
    const colIndex = getCellColumnIndex(state.cell);
    const isDeleteTable = state.tableContainer.deleteColumns(state.boundary, [colIndex], editor.root.parentNode);
    if (!isDeleteTable) {
        if (state.columnTool)
            state.columnTool.updateToolCells();
        editor.update(Quill.sources.USER);
        // Redistribute remaining column widths to fill editor width
        redistributeColumnWidths(editor, state.table);
        state.tableSelection?.clearSelection();
    }
}
export function deleteTable(editor, state) {
    const btModule = editor.getModule('better-table');
    btModule.hideTableTools();
    state.tableContainer.remove();
    editor.update(Quill.sources.USER);
}
